import { call, put, takeLatest } from 'redux-saga/effects';
import * as api from 'api/internalToolsUser/internalToolsUser';
import { CHANGE_PASSWORD } from 'state/actionTypes';
import * as toastActions from 'state/toast/actions';

export function* changePasswordSaga({ payload }) {
  const { oldPassword, newPassword } = payload;

  try {
    yield call(api.performChangePassword, {
      old_password: oldPassword,
      new_password: newPassword,
    });
    yield put(toastActions.successMessage(`Successfully changed password`));
  } catch (error) {
    yield put(
      toastActions.errorMessage('Failed to change password', error.message)
    );
  }
}

export default function* saga() {
  yield takeLatest(CHANGE_PASSWORD, changePasswordSaga);
}
